import api from '../api';
import apiUser from '../../components/entrada-segura/consult-components/services/api-user.service';

export type ApiResult<T> =
	| { ok: true; data: T }
	| { ok: false; status: number; code: string; message: string; attemptsLeft?: number; retryAfter?: number };

async function post<T>(url: string, body: unknown): Promise<ApiResult<T>> {
	try {
		// validateStatus: the shared interceptor in ../api swallows 4xx; this screen needs them.
		const response = await api.post(url, body, { validateStatus: () => true });
		if (response.status >= 200 && response.status < 300) {
			return { ok: true, data: response.data as T };
		}
		const detail = response.data?.detail;
		if (detail && typeof detail === 'object' && !Array.isArray(detail)) {
			return {
				ok: false,
				status: response.status,
				code: detail.code,
				message: detail.message,
				attemptsLeft: detail.attempts_left,
				retryAfter: detail.retry_after,
			};
		}
		return { ok: false, status: response.status, code: 'unknown', message: 'Não foi possível concluir. Tente de novo.' };
	} catch (error) {
		console.error('Error in account request:', error instanceof Error ? error.message : 'unknown error');
		return { ok: false, status: 0, code: 'network', message: 'Sem conexão com o servidor. Tente de novo.' };
	}
}

export const requestPasswordCode = () =>
	post<{ sent_to: string; expires_in: number; resend_after: number }>('/api/v1/account/password/request-code', {});

export const changePassword = (input: { currentPassword: string; code: string; newPassword: string }) =>
	post<{ changed_at: string; token: string }>('/api/v1/account/password/change', {
		current_password: input.currentPassword,
		code: input.code,
		new_password: input.newPassword,
	});

export function storeNewToken(token: string): void {
	// Same three places login() writes (services/login/login-service.tsx).
	localStorage.setItem('active-token', token);
	api.defaults.headers.Authorization = `Bearer ${token}`;
	apiUser.defaults.headers.Authorization = `Bearer ${token}`;
}
